"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const react_bootstrap_1 = require("react-bootstrap");
const URLs_1 = require("../utility/URLs");
const ImagePicker_1 = __importStar(require("../components/ImagePicker"));
const PageContentEditor_1 = __importDefault(require("../components/PageContentEditor"));
const ChangePageTitle_1 = __importDefault(require("../../commonFiles/ChangePageTitle"));
const node_html_parser_1 = require("node-html-parser");
const structure_1 = require("../../commonFiles/PageComponents/structure");
const structure_2 = require("../../commonFiles/PageComponents/structure");
const SelectWithApiSearch_1 = __importDefault(require("../components/SelectWithApiSearch"));
const FetchValueComponent_1 = __importDefault(require("../../commonFiles/FetchValueComponent"));
const moment_1 = __importDefault(require("moment"));
const categoriesMap = [
    { engName: 'Perception', arabId: 10 },
    { engName: 'Ancient Babylon', arabId: 9 },
    { engName: 'Adam-The Common Soul', arabId: 22 },
    { engName: 'Ancient Jerusalem', arabId: 47 },
    { engName: 'Anti-Semitism', arabId: 46 },
    { engName: 'Arts', arabId: 48 },
    { engName: 'Audio Version of the Blog', arabId: 49 },
    { engName: 'Baal HaSulam', arabId: 2 },
    { engName: 'Body and Soul', arabId: 15 },
    { engName: 'Books', arabId: 50 },
    { engName: 'Children', arabId: 51 },
    { engName: 'Collective Soul', arabId: 52 },
    { engName: 'Commandments', arabId: 53 },
    { engName: 'Contests', arabId: 54 },
    { engName: 'Conventions', arabId: 55 },
    { engName: 'Coronavirus', arabId: 56 },
    { engName: 'Crisis', arabId: 57 },
    { engName: 'Daily Kabbalah Lesson', arabId: 45 },
    { engName: 'Depression', arabId: 58 },
    { engName: 'Dissemination', arabId: 12 },
    { engName: 'Economy', arabId: 59 },
    { engName: 'Education', arabId: 28 },
    { engName: 'Egoism', arabId: 41 },
    { engName: 'Events', arabId: 60 },
    { engName: 'Evolution', arabId: 27 },
    { engName: 'Facebook', arabId: 61 },
    { engName: 'Family', arabId: 62 },
    { engName: 'Free Will', arabId: 18 },
    { engName: 'Globalization', arabId: 31 },
    { engName: 'Group Work', arabId: 16 },
    { engName: 'Health', arabId: 38 },
    { engName: 'Hebrew', arabId: 63 },
    { engName: 'History', arabId: 21 },
    { engName: 'Holidays', arabId: 64 },
    { engName: 'Humor', arabId: 65 },
    { engName: 'Inner Work', arabId: 23 },
    { engName: 'Integral Upbringing', arabId: 40 },
    { engName: 'Internet', arabId: 66 },
    { engName: 'Israel', arabId: 42 },
    { engName: 'Israel Today', arabId: 67 },
    { engName: 'Kabbalah Dissemination', arabId: 68 },
    { engName: 'Kabbalah for the Nation', arabId: 69 },
    { engName: 'Kabbalah Study', arabId: 70 },
    { engName: 'Kabbalistic Sources', arabId: 71 },
    { engName: 'Laitman Unplugged', arabId: 72 },
    { engName: 'Language of Branches', arabId: 24 },
    { engName: 'Lectures', arabId: 73 },
    { engName: 'Love', arabId: 33 },
    { engName: 'Maaser', arabId: 74 },
    { engName: 'Man and Woman', arabId: 39 },
    { engName: 'Marriage', arabId: 75 },
    { engName: 'Meaning Of Life', arabId: 26 },
    { engName: 'Movies', arabId: 76 },
    { engName: 'Music', arabId: 37 },
    { engName: 'Mutual Guarantee', arabId: 25 },
    { engName: 'Mutual Guarantee Movement', arabId: 77 },
    { engName: 'My Similarity to the Creator', arabId: 78 },
    { engName: 'Nations of the World', arabId: 34 },
    { engName: 'New Life', arabId: 79 },
    { engName: 'New Publications', arabId: 80 },
    { engName: 'News', arabId: 44 },
    { engName: 'Notices', arabId: 81 },
    { engName: 'Philosophy', arabId: 82 },
    { engName: 'Politics', arabId: 83 },
    { engName: 'Prayer and Intention', arabId: 84 },
    { engName: 'Q&A', arabId: 36 },
    { engName: 'Quora', arabId: 85 },
    { engName: 'Rabash', arabId: 5 },
    { engName: 'Religion', arabId: 17 },
    { engName: 'Science', arabId: 19 },
    { engName: 'Sex', arabId: 86 },
    { engName: 'Society', arabId: 87 },
    { engName: 'Society of the Future', arabId: 88 },
    { engName: 'Songs by Arkadi Duchin', arabId: 89 },
    { engName: 'Spiritual Teacher', arabId: 103 },
    { engName: 'Spiritual Work', arabId: 11 },
    { engName: 'Spirituality', arabId: 20 },
    { engName: 'Sports', arabId: 90 },
    { engName: 'Structure of the Universe', arabId: 91 },
    { engName: 'Suffering', arabId: 92 },
    { engName: 'Television', arabId: 93 },
    { engName: 'The Creator', arabId: 94 },
    { engName: 'The Tens', arabId: 95 },
    { engName: 'Thoughts on Twitter', arabId: 96 },
    { engName: 'Torah', arabId: 35 },
    { engName: 'Unity', arabId: 97 },
    { engName: 'US Elections', arabId: 98 },
    { engName: 'Videos', arabId: 99 },
    { engName: 'Women', arabId: 100 },
    { engName: 'Women is Spirituality', arabId: 101 },
    { engName: 'Workshops', arabId: 102 },
    { engName: 'World', arabId: 30 },
    { engName: 'Zohar', arabId: 14 },
    { engName: 'Сoronavirus', arabId: 56 },
];
function ArticleCreator(props) {
    // const [categories, setcategories] = React.useState([]);
    // const [page_id, setpage_id] = React.useState(null);
    // const [category_id, setcategory_id] = React.useState(null);
    const [categories_ids, setcategories_ids] = react_1.default.useState([]);
    const [title, settitle] = react_1.default.useState();
    const [description, setdescription] = react_1.default.useState();
    const [about, setabout] = react_1.default.useState();
    const [thumbnail, setthumbnail] = react_1.default.useState();
    const [activated, setactivated] = react_1.default.useState(false);
    const [page_content, setpage_content] = react_1.default.useState();
    const [source_url, setsource_url] = react_1.default.useState('');
    const [posted_on, setposted_on] = react_1.default.useState('');
    function submit() {
        (0, URLs_1.ApiCallHandler)(() => __awaiter(this, void 0, void 0, function* () { return yield URLs_1.Api.createArticle(categories_ids, title, description, about, thumbnail, activated, page_content, source_url, posted_on); }), (data) => {
            alert(data.success);
            setredirect(URLs_1.Routes.articleShow(data.id));
        }, 'Article Creator submit', true);
    }
    // React.useEffect(() => {
    //     ApiCallHandler(
    //         async () => await Api.fetchCategories({ withoutPagination: true }),
    //         setcategories,
    //         'ArticleCreator fetchCategories',
    //         false
    //     )
    // }, [])
    const [redirect, setredirect] = react_1.default.useState(null);
    if (redirect)
        return react_1.default.createElement(react_router_1.Redirect, { to: redirect });
    // const [laitmanBlogContent, dispatch] = React.useReducer(pageContentReducer, pageContentObject([], 'ltr', 'rtl'))
    function fetchFromLaitmanBlog() {
        (0, URLs_1.ApiCallHandler)(() => URLs_1.Api.fetchFromLaitmanBlog(source_url), null, 'Article Creator fetch From Laitman Blog', false).then((data) => __awaiter(this, void 0, void 0, function* () {
            let laitmanBlogContent = {
                class: structure_1.PageContentClass,
                pageComponents: [],
                originalDir: 'ltr',
                translatedDir: 'rtl',
            };
            const root = (0, node_html_parser_1.parse)(data.data);
            // console.log('post title', root.querySelector('.post>h2>a').childNodes[0].toString());
            laitmanBlogContent.pageComponents.push((0, structure_2.paragraphObject)(root.querySelector('.post>h2>a').childNodes[0].toString()));
            console.log('post date: ', root.querySelector('.postdate').childNodes[0].toString());
            // Create a moment object from the date string
            var date = (0, moment_1.default)(root.querySelector('.postdate').childNodes[0].toString(), "MMMM Do, YYYY at h:mm a");
            // Display the date in different formats
            // console.log('post date moment: ', date.format("YYYY-MM-DD")); // 2023-12-10
            // console.log('post date moment: ', date.format("dddd, MMMM Do, YYYY")); // Saturday, December 10th, 2023
            // console.log('post date moment: ', date.format("yyyy-MM-DDTH:mm")); // 7:46 am
            setposted_on(date.format("yyyy-MM-DDTH:mm"));
            laitmanBlogContent.pageComponents.push((0, structure_2.paragraphObject)(root.querySelector('.postdate').childNodes[0].toString()));
            const content = root.querySelector('.entry').childNodes;
            for (let index = 0; index < content.length; index++) {
                const p = content[index];
                // console.log('post content p tag', p.toString())
                const pTag = (0, node_html_parser_1.parse)(p.toString());
                const imgsrc = pTag.querySelector('img');
                if (imgsrc) {
                    let base642 = yield (0, ImagePicker_1.getBase64FromUrl)(imgsrc.getAttribute('src'));
                    if (!thumbnail)
                        setthumbnail(base642);
                    // console.log('post content p tag imgsrc', imgsrc.getAttribute('src'))
                    laitmanBlogContent.pageComponents.push((0, structure_1.imageObject)(base642));
                }
                if (p.innerText.length > 6) {
                    // console.log('p.innerText', p.toString())
                    // console.log('p.innerText,.length', p.innerText.length)
                    laitmanBlogContent.pageComponents.push((0, structure_2.paragraphObject)(p.innerText));
                }
            }
            setpage_content(laitmanBlogContent);
            setactivated(true);
            const postmetadataATag = root.querySelectorAll('.postmetadata>a');
            for (let index = 0; index < postmetadataATag.length; index++) {
                const a = postmetadataATag[index];
                console.log('postmetadata content a tag', a.childNodes.toString());
                for (let ii = 0; ii < categoriesMap.length; ii++) {
                    if (a.childNodes.toString() == categoriesMap[ii].engName) {
                        console.log('categoriesMap[ii]', categoriesMap[ii]);
                        if (!categories_ids.find((id) => id == categoriesMap[ii].arabId))
                            setcategories_ids((pre) => [...pre, categoriesMap[ii].arabId]);
                    }
                }
            }
        }));
    }
    return react_1.default.createElement("div", null,
        react_1.default.createElement(ChangePageTitle_1.default, { pageTitle: "إنشاء مقالة" }),
        react_1.default.createElement("div", { className: 'd-flex align-items-center fs-4 ' },
            react_1.default.createElement("i", { className: "bi bi-journal-text" }),
            react_1.default.createElement("div", { className: 'mx-2' }, "\u0625\u0646\u0634\u0627\u0621 \u0645\u0642\u0627\u0644\u0629")),
        react_1.default.createElement("div", { className: "bg-white rounded shadow p-2 my-2" },
            react_1.default.createElement(react_bootstrap_1.FormCheck, { className: "my-2" },
                react_1.default.createElement("div", { className: "d-flex fs-5" },
                    react_1.default.createElement("i", { className: "bi bi-1-circle" }),
                    react_1.default.createElement(react_bootstrap_1.FormCheck.Label, { className: "mx-2" }, "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0645\u0642\u0627\u0644\u0629")),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: 'text', onChange: (e) => settitle(e.target.value) })),
            react_1.default.createElement(react_bootstrap_1.FormCheck, { className: "my-2" },
                react_1.default.createElement("div", { className: "d-flex " },
                    react_1.default.createElement("i", { className: "bi bi-share fs-5" }),
                    react_1.default.createElement(react_bootstrap_1.FormCheck.Label, { className: "fs-5" }, "\u0648\u0635\u0641 \u0627\u0644\u0645\u0642\u0627\u0644\u0629")),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { as: 'textarea', onChange: (e) => setdescription(e.target.value) })),
            react_1.default.createElement(react_bootstrap_1.FormCheck, { className: "my-2" },
                react_1.default.createElement(react_bootstrap_1.FormCheck.Label, { className: "fs-5" }, "\u062D\u0648\u0644 \u0627\u0644\u0645\u0642\u0627\u0644\u0629 (\u0644\u0627\u064A\u0638\u0647\u0631 \u0644\u0644\u0645\u062A\u0635\u0641\u062D\u064A\u0646)"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { as: 'textarea', onChange: (e) => setabout(e.target.value) })),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "d-flex" },
                    react_1.default.createElement("div", { className: "fs-5" }, "\u062A\u0635\u0646\u064A\u0641\u0627\u062A \u0627\u0644\u0645\u0642\u0627\u0644"),
                    react_1.default.createElement("div", { className: "w-50 mx-2" },
                        react_1.default.createElement(SelectWithApiSearch_1.default, { paginationEndpoint: (params) => URLs_1.Api.fetchCategories(Object.assign({}, params)), label: "\u0625\u0636\u0627\u0641\u0629 \u062A\u0635\u0646\u064A\u0641", setSelectedValue: (value) => {
                                if (!categories_ids.find((id) => id == value))
                                    setcategories_ids((pre) => [...pre, value]);
                            }, 
                            // value={ }
                            valueKeyWord: "id", nameKeyWord: "name" }))),
                react_1.default.createElement("div", { className: "d-flex flex-wrap" }, categories_ids === null || categories_ids === void 0 ? void 0 : categories_ids.map((id, index) => (react_1.default.createElement("div", { key: index, className: "ms-2 my-2 d-flex border rounded p-2" },
                    react_1.default.createElement(FetchValueComponent_1.default, { update: categories_ids, apiCall: () => URLs_1.Api.categoryName(id) }),
                    react_1.default.createElement("div", { className: "me-1 cursor-pointer", onClick: e => {
                            setcategories_ids((current) => {
                                console.log('current', current);
                                console.log('id', id.toString());
                                console.log(current.filter((_id) => _id != id));
                                return current.filter((_id) => _id != id);
                            });
                        } }, "X")))))),
            react_1.default.createElement("div", { className: "d-flex" },
                react_1.default.createElement("div", { className: "fs-5" }, "\u0645\u0641\u0639\u0644\u0651\u0629 \u0644\u0644\u0639\u0631\u0636"),
                react_1.default.createElement("input", { className: "m-2", 
                    // inline
                    // label="مفعلّة للعرض"
                    type: 'checkbox', 
                    // defaultChecked={activated}
                    checked: activated, onChange: (e) => {
                        setactivated(e.target.checked);
                    } })),
            react_1.default.createElement("div", { className: "my-2" },
                react_1.default.createElement("div", { className: "fs-5" }, "\u0635\u0648\u0631\u0629 \u0627\u0644\u0648\u0627\u062C\u0647\u0629"),
                react_1.default.createElement("img", { src: thumbnail, width: 100 }),
                react_1.default.createElement(ImagePicker_1.default, { setImage: (base64) => setthumbnail(base64) })),
            react_1.default.createElement("div", { className: "my-2" },
                react_1.default.createElement("div", { className: "fs-5" }, "\u062A\u0627\u0631\u064A\u062E \u0648\u062A\u0648\u0642\u064A\u062A \u0627\u0644\u0646\u0634\u0631"),
                react_1.default.createElement("input", { type: 'datetime-local', onChange: e => {
                        console.log('datetime-local', e.target.value);
                        setposted_on(e.target.value);
                    }, value: posted_on !== null && posted_on !== void 0 ? posted_on : '' })),
            react_1.default.createElement("div", { className: "d-flex align-items-end " },
                react_1.default.createElement("div", { className: "mx-2 flex-grow-1" },
                    react_1.default.createElement("div", { className: "d-flex " },
                        react_1.default.createElement("i", { className: "bi bi-link fs-5" }),
                        react_1.default.createElement(react_bootstrap_1.FormCheck.Label, { className: "fs-5 mx-2" }, "\u0631\u0627\u0628\u0637 \u0627\u0644\u0645\u0635\u062F\u0631")),
                    react_1.default.createElement(react_bootstrap_1.Form.Control, { type: 'text', value: source_url, onChange: (e) => setsource_url(e.target.value) })),
                react_1.default.createElement("button", { className: "btn btn-success text-white", onClick: e => {
                        fetchFromLaitmanBlog();
                    } }, "Fetch from Laitman blog"))),
        react_1.default.createElement(react_bootstrap_1.Button, { onClick: submit }, "submit"),
        react_1.default.createElement("div", { className: "bg-white rounded shadow p-3 my-2" },
            react_1.default.createElement(PageContentEditor_1.default, { setEditedPageContent: setpage_content, pageContent: page_content })),
        react_1.default.createElement(react_bootstrap_1.Button, { onClick: submit }, "submit"));
}
exports.default = ArticleCreator;
